module.exports = __webpack_public_path__ + "static/media/ESGReports.6e3d11e4.svg";